import PaintEditor from './containers/tw-paint-editor-wrapper.jsx';
import ScratchPaintReducer from './reducers/scratch-paint-reducer';

export { PaintEditor as default, ScratchPaintReducer };
